import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'role_general_info';
export const useRoleGeneralInfoTranslation = (): UseTranslationResponse<'entities', typeof keyPrefix> => useTranslation('entities', { keyPrefix });
export const ruRu = ({
  [keyPrefix]: {
    title: 'Общая информация',
    fields: {
      name: 'Название',
      description: 'Описание',
      created: 'Создано',
      updated: 'Изменено',
    },
  },
}) as Record<string, unknown>;
export const en = ({
  [keyPrefix]: {
    title: 'General information',
    fields: {
      name: 'Name',
      description: 'Description',
      created: 'Created',
      updated: 'Updated',
    },
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    title: 'Información general',
    fields: {
      name: 'Nombre',
      description: 'Descripción',
      created: 'Creado',
      updated: 'Actualizado',
    },
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [keyPrefix]: {
    title: 'Informações gerais',
    fields: {
      name: 'Nome',
      description: 'Descrição',
      created: 'Criado',
      updated: 'Atualizado',
    },
  },
}) as Record<string, unknown>;
